import { render, staticRenderFns } from "./AppStoreDeleteReviewResponse.vue?vue&type=template&id=16831d24&scoped=true"
import script from "./AppStoreDeleteReviewResponse.vue?vue&type=script&lang=js"
export * from "./AppStoreDeleteReviewResponse.vue?vue&type=script&lang=js"
import style0 from "./AppStoreDeleteReviewResponse.vue?vue&type=style&index=0&id=16831d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16831d24",
  null
  
)

export default component.exports